import {
  WithdrawalNotificationRecipient,
  WithdrawalPlanType,
  WithdrawalRequestSource,
  WithdrawalRequestStatus,
} from "../../SpeakingClassService/Withdrawal/WithdrawalRequestDTO.ts";
import { STUDENTS_TEAM_EMAIL } from "./withdrawalWindow.ts";

export const WITHDRAWAL_STATUS_LABELS: Record<WithdrawalRequestStatus, string> =
  {
    [WithdrawalRequestStatus.Pending]: "In carico",
    [WithdrawalRequestStatus.ToRefund]: "Da rimborsare",
    [WithdrawalRequestStatus.WithdrawalAvoided]: "Recesso evitato",
    [WithdrawalRequestStatus.Refunded]: "Rimborsata",
    [WithdrawalRequestStatus.PartiallyRefunded]: "Rimborso parziale",
    [WithdrawalRequestStatus.Cancelled]: "Annullata",
  };

export const WITHDRAWAL_STATUS_COLORS: Record<WithdrawalRequestStatus, string> =
  {
    [WithdrawalRequestStatus.Pending]:
      "bg-yellow-100 text-yellow-800 border border-yellow-300",
    [WithdrawalRequestStatus.ToRefund]:
      "bg-orange-100 text-orange-800 border border-orange-300",
    [WithdrawalRequestStatus.WithdrawalAvoided]:
      "bg-blue-100 text-blue-800 border border-blue-300",
    [WithdrawalRequestStatus.Refunded]:
      "bg-green-100 text-green-800 border border-green-300",
    [WithdrawalRequestStatus.PartiallyRefunded]:
      "bg-teal-100 text-teal-800 border border-teal-300",
    [WithdrawalRequestStatus.Cancelled]:
      "bg-gray-100 text-gray-700 border border-gray-300",
  };

export const WITHDRAWAL_SOURCE_LABELS: Record<WithdrawalRequestSource, string> =
  {
    [WithdrawalRequestSource.Platform]: "Piattaforma",
    [WithdrawalRequestSource.Internal]: "Interno",
  };

export const WITHDRAWAL_PLAN_TYPE_LABELS: Record<WithdrawalPlanType, string> = {
  [WithdrawalPlanType.Group]: "Gruppo",
  [WithdrawalPlanType.OneOnOne]: "1to1",
};

export const WITHDRAWAL_RECIPIENT_LABELS: Record<
  WithdrawalNotificationRecipient,
  string
> = {
  [WithdrawalNotificationRecipient.Closer]: "Closer della trattativa",
  [WithdrawalNotificationRecipient.FallbackTeamLeader]:
    "Team leader di fallback (closer non individuato)",
  [WithdrawalNotificationRecipient.StudentsTeam]: `${STUDENTS_TEAM_EMAIL} (recesso extra legacy)`,
};
